import Url from 'environment';
import Api from '../../api';
import autobind from 'autobind-decorator';

@autobind
class ScoreLineupService extends Api {
  constructor() {
    super();
  }

  /**
   * @description
   * @param {*} sportsType
   * @param {*} gameId
   * @returns
   */
  getSportsTypeByGameId(sportsType, gameId) {
    return this.ajax(
      'get',
      Url.sports,
      `/sports/${
        sportsType === 'icehockey' ? 'hockey' : sportsType
      }/games/${gameId}`
    ).then((res) => {
      if (res.status === 200) return res.data;
    });
  }
}

export default new ScoreLineupService();
